import api from "@/services/modules/auth";
import {
  SET_ERROR,
  SET_FETCHING_USERS,
  SET_IS_LOADING_SELF_DETAILS,
  SET_USERS_TO_IMPERSONATE
} from "./mutation-types";
import {
  FETCH_SELF_DETAILS,
  FETCH_USERS_TO_IMPERSONATE,
  SELECT_PROFILE
} from "./action-types";
import { setStoreValue } from "@/store/utils";
import { handleWithErrorMessage } from "@/services/utils";
import {
  SET_MODULE_PERMISSIONS_AS_CURRENT,
  SET_PERMISSIONS,
  SET_USER_DATA,
  SET_SELECTED_PROFILE,
  SET_PROFILES,
  SET_LOGO_URL,
  SET_API_ERROR
} from "@/store/modules/auth/mutation-types";
import getters from "@/store/modules/auth/getters";
import {
  getSelectedProfile,
  getImpersonateUserId,
  getOriginDomain
} from "@/services/utils";
import { find, size, first } from "lodash";

const state = {
  usersToImpersonate: [],
  userData: {},
  userToken: "",
  isLoadingSelfDetails: false,
  isFetchingUsers: false,
  authenticatingError: null,
  permissions: null,
  selectedProfile: null,
  profiles: [],
  logoUrl: null,
  apiError: false
};

const actions = {
  async [FETCH_SELF_DETAILS]({ dispatch, commit }) {
    try {
      commit(SET_IS_LOADING_SELF_DETAILS, true);
      const params = { origin_domain: getOriginDomain() };
      const { data, meta } = await api(commit).me(params);
      if (data && meta) {
        const { permissions, tokens, logoUrl } = meta;
        const impersonating = Boolean(getImpersonateUserId());
        commit(SET_USER_DATA, data);
        commit(SET_PERMISSIONS, permissions);
        commit(SET_PROFILES, tokens);
        commit(SET_LOGO_URL, logoUrl);
        if (size(tokens) === 1 && !impersonating) {
          dispatch(SELECT_PROFILE, { profile: first(tokens) });
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      commit(SET_IS_LOADING_SELF_DETAILS, false);
    }
  },
  async [FETCH_USERS_TO_IMPERSONATE]({ dispatch, commit }, search = "") {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getUsersToImpersonate({ search }),
      setLoadingFunction: isLoading => commit(SET_FETCHING_USERS, isLoading),
      setDataFunction: ({ data }) => commit(SET_USERS_TO_IMPERSONATE, data)
    });
  },
  async [SELECT_PROFILE]({ state, dispatch, commit }, { profile, refresh }) {
    commit(SET_IS_LOADING_SELF_DETAILS, true);
    commit(SET_SELECTED_PROFILE, profile);
    localStorage.setItem("selectedProfile", JSON.stringify(profile));
    localStorage.setItem("token", profile.token);
    if (refresh && size(state.profiles) > 1) {
      dispatch(FETCH_SELF_DETAILS);
    }
  }
};

const mutations = {
  [SET_USER_DATA]: setStoreValue("userData"),
  [SET_IS_LOADING_SELF_DETAILS]: setStoreValue("isLoadingSelfDetails"),
  [SET_ERROR]: setStoreValue("authenticatingError"),
  [SET_USERS_TO_IMPERSONATE]: setStoreValue("usersToImpersonate"),
  [SET_FETCHING_USERS]: setStoreValue("isFetchingUsers"),
  [SET_LOGO_URL]: setStoreValue("logoUrl"),
  [SET_PERMISSIONS]: (state, permissions) => {
    state.permissions = { ...state.permissions, ...permissions };
  },
  [SET_MODULE_PERMISSIONS_AS_CURRENT]: (state, { module, id }) => {
    state.permissions = Object.fromEntries(
      Object.entries(state.permissions).map(([permission, isAllowed]) => {
        const currentIndex = `[${id}]`;
        if (permission.startsWith(`${module}${currentIndex}`)) {
          return [permission.replace(currentIndex, ""), isAllowed];
        }
        return [permission, isAllowed];
      })
    );
  },
  [SET_SELECTED_PROFILE]: setStoreValue("selectedProfile"),
  [SET_PROFILES]: (state, profiles) => {
    const impersonating = Boolean(getImpersonateUserId());
    if (!impersonating) {
      state.profiles = profiles;
      const selectedProfile = getSelectedProfile();
      if (selectedProfile) {
        const profileToBeStored = find(profiles, { id: selectedProfile.id });
        state.selectedProfile = profileToBeStored;
        localStorage.setItem(
          "selectedProfile",
          JSON.stringify(profileToBeStored)
        );
        profileToBeStored &&
          localStorage.setItem("token", profileToBeStored.token);
      }
    }
  },
  [SET_API_ERROR]: setStoreValue("apiError")
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
